import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectQuote = state => state.get('quote', initialState);

const selectQuotation = state => state.get('quotation', initialState);

const makeSelectQuote = () =>
  createSelector(selectQuote, quotationState => quotationState.get('quotation'));

const makeSelectQuotationCode = () =>
  createSelector(selectQuotation, quotationState => quotationState.get('code'));

const makeSelectProposalId = () =>
  createSelector(selectQuotation, quotationState => quotationState.get('proposal_id'));

const makeSelectCustomerCode = () =>
  createSelector(selectQuote, quotationState => quotationState.get('customerCode'));

const makeSelectCustomerContractualCategory = () =>
  createSelector(selectQuote, quotationState => quotationState.get('contractualCategory'));

const makeSelectCustomer = () =>
  createSelector(selectQuote, quotationState => quotationState.get('customer'));

const makeSelectLoading = () =>
  createSelector(selectQuote, offersState => offersState.get('loading'));

const makeSelectSearchingCustomer = () =>
  createSelector(selectQuote, quotationState => quotationState.get('search'));

const makeSelectCustomerFound = () =>
  createSelector(selectQuote, quotationState => quotationState.get('customerFound'));

const makeSelectCustomerUpdatedInput = () =>
  createSelector(selectQuote, quotationState => quotationState.get('customerUpdatedInput'));

const makeSelectQuotattionAttachments = () =>
  createSelector(selectQuote, quotationState => quotationState.get('attachments'));

const selectErrors = () =>
  createSelector(selectQuote, quotationState => {
    const errors = quotationState.get('errors');

    if (errors && !errors.hasOwnProperty('__altered')) {
      return Object.entries(quotationState.get('errors')).reduce(
        (result, field) => {
          const [fieldName, value] = field;
          result[fieldName] = value[0];
          return result;
        },
        {},
      );
    }
  });

const selectHasErrors = () =>
  createSelector(selectQuote, quotationState => quotationState.get('hasErrors'));

const selectUpdated = () =>
  createSelector(selectQuote, quotationState => quotationState.get('updated'));

export {
  selectQuotation,
  makeSelectLoading,
  makeSelectQuotationCode,
  makeSelectProposalId,
  makeSelectCustomerContractualCategory,
  makeSelectCustomerCode,
  makeSelectSearchingCustomer,
  makeSelectCustomer,
  makeSelectCustomerFound,
  makeSelectCustomerUpdatedInput,
  makeSelectQuote,
  makeSelectQuotattionAttachments,
  selectErrors,
  selectHasErrors,
  selectUpdated,
};
